<script setup>
import { ref } from 'vue';
import { usePaymentsStore } from '@/stores/payments';
import ProfileTab from './Tabs/ProfileTab.vue';
import PaymentsTab from './Tabs/Payments.vue';
import SubscriptionsTab from './Tabs/SubscriptionsTab.vue';
import { storeToRefs } from 'pinia';

const activeTab = ref('profile');
const paymentsStore = usePaymentsStore();
const { paymentMethods } = storeToRefs(paymentsStore);

const tabs = [
    { name: 'profile', component: ProfileTab, label: 'Profile' },
    { name: 'payments', component: PaymentsTab, label: 'Payments' },
    { name: 'subscription', component: SubscriptionsTab, label: 'Subscription' },
];
</script>

<template>
<MainContentLayout>
    <template #breadcrumb>
        <BreadCrumb />
    </template>
    <template #title>
        <div class="mb-3 mt-2 flex gap-2">
            <StyledButton
                v-for="tab in tabs"
                :key="tab.name"
                class="custom-tab-btn"
                :variant="activeTab === tab.name ? 'contained' : 'outlined'"
                size="small"
                :disabled="tab.name === 'subscription' && (!paymentMethods || paymentMethods.length === 0)"
                @click="activeTab = tab.name">
                {{ tab.label }}
            </StyledButton>
        </div>
    </template>
    <template #actions>
        <StyledButton
            v-if="activeTab === 'profile'"
            size="small"
            class="custom-tab-btn"
            variant="outlined"
            @click="$inertia.visit('/profile/security-questions')">
            <FontAwesomeIcon
                icon="lock"
                class="mr-1 custom-tab-btn-icon" />
            {{ $t('label.change_security_questions_and_answers') }}
        </StyledButton>
    </template>
    <div>
        <ProfileTab v-if="activeTab === 'profile'" />
        <PaymentsTab v-else-if="activeTab === 'payments'" />
        <SubscriptionsTab v-else-if="activeTab === 'subscription' && paymentMethods && paymentMethods.length > 0" />
    </div>
</MainContentLayout>
</template>

<style scoped>
    .custom-tab-btn {
        border-color: #00594C !important;
        color: #00594C !important;
    }
    .custom-tab-btn-icon {
        color: #00594C !important;
    }
</style>
